export function Header2Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 4a1 1 0 011 1v6h4V5a1 1 0 112 0v14a1 1 0 11-2 0v-6H6v6a1 1 0 11-2 0V5a1 1 0 011-1zm10.13 8.178c-.486.394-.816.867-.99 1.417.12.17.304.315.554.435.25.12.503.185.758.195a2.17 2.17 0 01.51-.772c.23-.226.505-.338.825-.338.3 0 .54.098.72.293a.978.978 0 01.277.697c0 .25-.07.482-.21.697-.14.216-.325.415-.555.6l-1.387 1.185a7.85 7.85 0 00-1.11 1.163c-.325.415-.488.808-.488 1.177 0 .186.08.388.24.608.16.22.3.38.42.48h4.028c.67 0 1.052-.29 1.147-.87.015-.095.025-.212.03-.352.005-.14.008-.255.008-.345h-2.04c-.215 0-.493.012-.833.037-.34.025-.69.063-1.05.113.07-.15.205-.318.405-.503.2-.19.415-.375.645-.555l1.058-.855c.42-.34.785-.717 1.095-1.132.31-.416.465-.888.465-1.418 0-.49-.113-.928-.338-1.313a2.37 2.37 0 00-.96-.907c-.41-.225-.895-.337-1.455-.337-.695 0-1.285.2-1.77.6z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
